import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { apiService } from '../../services/apiService';
import { Box } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

function ViewedCadidates() {
    const { slug } = useParams();
    const permissionstest = JSON.parse(localStorage.getItem('permissions'));
    const [jobsApplylist, setApplyJobs] = useState([]);
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [loadingApplied, setLoadingApplied] = useState(true);

    const fetchJobs = useCallback(async (params = {}) => {
        setLoadingApplied(true);
        try {
            const defaultParams = {...params };
            const queryString = new URLSearchParams(defaultParams).toString();
            const response = await apiService.getRequest(`/job-posts/${slug}/views?${queryString}`);
            // const response = await apiService.postRequest(`/job-posts/${slug}/views`, defaultParams);
            if (response && response.success === true) {
                setApplyJobs(response.data);
                setPaginateData(response.meta);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoadingApplied(false);
        }
    }, [slug]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchJobs({ page: newPage });
    };
    const handleSearch = () => {
        setCurrentPage(1);
        fetchJobs({ search: searchQuery });
    };

    useEffect(() => {
        fetchJobs();
    }, [fetchJobs]);

  return (
    <Grid size={{xs:12}} container>
        <Grid size={{xs:12}} container className='my-4'>
            <Grid size={{ sm:5,xs: 12 }} container flexDirection="column">
                <div className='d-flex jobseekersearch my-3'>
                    <div className='col-md-9 input_jobssearch'>
                        <FontAwesomeIcon className='iconcol' icon={faMagnifyingGlass} />
                        <input type='text' placeholder='search'
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                handleSearch(); // Trigger search on Enter key press
                            }
                        }}/>
                    </div>
                    <div className='col-md-3 col-4'>
                        <button onClick={handleSearch}>Search</button>
                    </div>
                </div>
            </Grid>
        </Grid>
        {loadingApplied ? 
            <div className='d-flex justify-content-center w-100 mt-5 pt-5'>
                <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
            </div> :
        <Grid size={{xs:12}} container>
            {jobsApplylist && jobsApplylist.length > 0 ?
                <Box sx={{ width: "100%", mt: 2 }} className="dtagridcand_pagi">
                    <DataGrid
                        style={{minHeight:"200px"}}
                        rows={jobsApplylist && jobsApplylist.map((field, fieldIndex) => ({
                            id: fieldIndex + 1,
                            jobseekerName: field?.user?.name,
                            jobseekerId: field?.user?.id,
                            formatid: field?.user?.formatted_id,
                            phoneNumber: field?.user?.phone_number || "N/A",
                            email: field?.user?.email || "N/A",
                            viewedAt: field.viewed_at || "N/A",
                        }))}
                        columns={[
                            {
                                field: 'id',
                                headerName: 'S.No',
                                width: 120,
                                renderCell: (params) => (
                                    <div className='d-flex align-items-center h-100'>
                                        <span style={{color:"#1a5298"}} className='firstlett_caps'>
                                            {params.row.id}
                                        </span>
                                    </div>
                                ),
                                filterable: false,
                                sortable: true,
                            },
                            {
                                field: 'formatid',
                                headerName: 'Jobseeker No',
                                width: 250,
                                renderCell: (params) => (
                                    <div className='d-flex align-items-center h-100'>
                                        {permissionstest && (permissionstest.manage_jobseeker_reader || permissionstest.manage_jobseeker_writer) ? 
                                            <Link to={`/user/jobseeker-details/${params.row.id}`} target='_blank' className='cursetespoint' style={{color:"#C42B7D",textDecoration:'none'}} >{params.row.formatid}</Link>:
                                            <span style={{color:"#C42B7D"}} >{params.row.formatid}</span>
                                        }
                                    </div>
                                ),
                                filterable: false,
                                sortable: true,
                            },
                            {
                                field: 'jobseekerName',
                                headerName: 'Jobseeker Name',
                                width: 350,
                                renderCell: (params) => (
                                    <div className='d-flex align-items-center h-100'>
                                        <span className='firstlett_caps'>
                                            {params.row.jobseekerName}
                                        </span>
                                    </div>
                                ),
                                filterable: false,
                                sortable: true,
                            },
                            {
                                field: 'phoneNumber',
                                headerName: 'Phone Number',
                                width: 300,
                                filterable: false,
                                sortable: false,
                            },
                            {
                                field: 'email',
                                headerName: 'Email',
                                width: 300,
                                filterable: false,
                                sortable: false,
                            },
                            {
                                field: 'viewedAt',
                                headerName: 'Viewed At',
                                width: 200,
                                filterable: false,
                                sortable: true,
                            },
                        ]}
                        disableSelectionOnClick
                        components={{ Toolbar: GridToolbar }}
                    />
                </Box>
                    : (
                <div className="w-100 d-flex justify-content-center mt-4">
                    <p>No data to display</p>
                </div>
            )}
            <Grid size={{xs:12}} container justifyContent="space-between">
                <div className='d-flex justify-content-end align-items-center mt-3'>
                    <label className='me-2'>Showing records <b>{paginatedata.from}</b>-<b>{paginatedata.to}</b> out of <b>{paginatedata.total}</b></label>
                </div>
            </Grid>
            <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                <button className='arrowpaginate'
                    onClick={() => handlePageChange(currentPage - 1)} 
                    disabled={currentPage === 1}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                {paginatedata && (
                    <div className="pagination">
                        {(() => {
                        const totalPages = paginatedata.last_page > 0 ? paginatedata.last_page : 1;
                        const pages = [];
                        const start = Math.max(2, currentPage - 2);
                        const end = Math.min(totalPages - 1, currentPage + 2);

                        // Always show first page
                        pages.push(
                            <button
                            key={1}
                            onClick={() => handlePageChange(1)}
                            className={currentPage === 1 ? 'active' : ''}
                            >
                            1
                            </button>
                        );

                        if (start > 2) {
                            pages.push(<span key="start-ellipsis">...</span>);
                        }

                        for (let i = start; i <= end; i++) {
                            pages.push(
                            <button
                                key={i}
                                onClick={() => handlePageChange(i)}
                                className={currentPage === i ? 'active' : ''}
                            >
                                {i}
                            </button>
                            );
                        }

                        if (end < totalPages - 1) {
                            pages.push(<span key="end-ellipsis">...</span>);
                        }

                        if (totalPages > 1) {
                            pages.push(
                            <button
                                key={totalPages}
                                onClick={() => handlePageChange(totalPages)}
                                className={currentPage === totalPages ? 'active' : ''}
                            >
                                {totalPages}
                            </button>
                            );
                        }

                        return pages;
                        })()}
                    </div>
                    )}

                <button className='arrowpaginate'
                    onClick={() => handlePageChange(currentPage + 1)} 
                    disabled={currentPage === paginatedata.last_page}>
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </Grid>
        </Grid>}
    </Grid>
  )
}

export default ViewedCadidates
